/** Полный снимок оверлеев Target Attack (HUD, пауза, game over). Обновляется из `tvAppBootstrap`. */
export type LegKickUiSnapshot = {
  hudVisible: boolean;
  pauseVisible: boolean;
  gameOverVisible: boolean;
  score: number;
  split: boolean;
  player1Score: number | null;
  player2Score: number | null;
  pauseSplit: boolean;
  pauseScoreSingle: number;
  pauseP1: number | null;
  pauseP2: number | null;
  lives: number | null;
  timeLeftSec: number | null;
  timerUrgent: boolean;
  gameMode: 'CLASSIC' | 'ARCADE' | 'ZEN' | null;
  streak: number;
  comboCount: number | null;
  currentLevel: number | null;
  levelProgress: number | null;
};

const initial: LegKickUiSnapshot = {
  hudVisible: false,
  pauseVisible: false,
  gameOverVisible: false,
  score: 0,
  split: false,
  player1Score: null,
  player2Score: null,
  pauseSplit: false,
  pauseScoreSingle: 0,
  pauseP1: null,
  pauseP2: null,
  lives: null,
  timeLeftSec: null,
  timerUrgent: false,
  gameMode: null,
  streak: 0,
  comboCount: null,
  currentLevel: null,
  levelProgress: null,
};

let snapshot: LegKickUiSnapshot = { ...initial };
const listeners = new Set<() => void>();

function same(a: LegKickUiSnapshot, b: LegKickUiSnapshot): boolean {
  return (
    a.hudVisible === b.hudVisible &&
    a.pauseVisible === b.pauseVisible &&
    a.gameOverVisible === b.gameOverVisible &&
    a.score === b.score &&
    a.split === b.split &&
    a.player1Score === b.player1Score &&
    a.player2Score === b.player2Score &&
    a.pauseSplit === b.pauseSplit &&
    a.pauseScoreSingle === b.pauseScoreSingle &&
    a.pauseP1 === b.pauseP1 &&
    a.pauseP2 === b.pauseP2 &&
    a.lives === b.lives &&
    a.timeLeftSec === b.timeLeftSec &&
    a.timerUrgent === b.timerUrgent &&
    a.gameMode === b.gameMode &&
    a.streak === b.streak &&
    a.comboCount === b.comboCount &&
    a.currentLevel === b.currentLevel &&
    a.levelProgress === b.levelProgress
  );
}

export function getLegKickUiSnapshot(): LegKickUiSnapshot {
  return snapshot;
}

export function subscribeLegKickUi(onStoreChange: () => void): () => void {
  listeners.add(onStoreChange);
  return () => listeners.delete(onStoreChange);
}

export function setLegKickUiSnapshot(next: LegKickUiSnapshot): void {
  if (same(snapshot, next)) return;
  snapshot = { ...next };
  listeners.forEach((l) => l());
}

export function patchLegKickUi(patch: Partial<LegKickUiSnapshot>): void {
  setLegKickUiSnapshot({ ...snapshot, ...patch });
}

export function resetLegKickUi(): void {
  setLegKickUiSnapshot({ ...initial });
}
